import { CdkDragDrop, moveItemInArray } from "@angular/cdk/drag-drop";
import { ChangeDetectorRef, Component, EventEmitter, Input, NgZone, OnChanges, Output, SimpleChanges } from "@angular/core";
import { ConfirmationService, MessageService } from "primeng/api";
import { AppMainService } from "../../../../app-main.service";
import { SharedExportService } from '../../services/export-modal.service';
import { AppMainComponent } from '../../../../app.main.component';
import { UpdateExport } from "../../models/export.model";
import { SectionN } from "../../models/column-settings.model";
import { Subject, takeUntil } from "rxjs";
import { OrganizationSubscriptionService } from "../../services/organization-subscription.service";
import { SubscriptionFeatureLimitM } from "../../models/organization-subscription/subscription-feature-limit.modal";
import { FeatureSubscriptionInfoEnums } from "../../enums/feature-subscription-info.enum";
import { AccountModuleId, CaseModuleId, OpportunityModuleId } from "../../constants/modules.constant";

@Component({
    selector: 'app-shared-export-modal-new',
    styleUrls: ['./export-modal.component.scss'],
    templateUrl: './export-modal.component.html',
})
export class SharedExportModalComponent implements OnChanges {


    @Input() moduleName: string = '';
    @Input() objectId: number;
    @Input() channel: any;
    @Input() selectedRecent: any;
    @Input() allListColumns: any = [];
    @Input() display: boolean = false;
    @Input() isActive: boolean = false;
    @Input() channelId: number;
    @Input() accountChannelId: number;
    @Input() stageId: number = null;
    @Input() workbookId: string = null;
    @Input() workbookName: string = null;
    @Input() workspaceName: string = null

    @Output() cancelClicked = new EventEmitter();
    @Output() onExportComplete = new EventEmitter();

    displayExport: boolean = false;
    listSearchInput: string = '';

    exportFields = [];

    currentModuleName = '';
    currentallListColumns : SectionN[] = [];
    currentallListColumnsVM : SectionN[] = [];
    currentExportListData = [];
    currentDisplay = false;
    currentDownloadExcelVal = false;
    showExportFileType:boolean=false

    updateExportModel: Partial<UpdateExport> = {};

    private ngUnsubscribe = new Subject<void>();

    subscriptionLimit: SubscriptionFeatureLimitM = null;
    isSelectAllSectionField: boolean = false;

    constructor(
        public app: AppMainComponent,
        private confirmationService: ConfirmationService,
        private messageService: MessageService,
        private cdr: ChangeDetectorRef,
        public appMainService: AppMainService,
        private sharedExportService: SharedExportService,
        private organizationSubscriptionService: OrganizationSubscriptionService
    ) {

    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.moduleName && changes.moduleName.currentValue) {
            this.currentModuleName = changes.moduleName.currentValue;
        }
        if (changes.allListColumns && changes.allListColumns.currentValue) {
            const currentallListColumns = JSON.parse(JSON.stringify(changes.allListColumns.currentValue));
            this.currentallListColumns = currentallListColumns.sort((a, b) => { return a.displayOrder - b.displayOrder })
            this.currentallListColumnsVM = JSON.parse(JSON.stringify(changes.allListColumns.currentValue));
        }
        if (changes.exportListData && changes.exportListData.currentValue) {
            this.currentExportListData = changes.exportListData.currentValue;
        }

        if (changes.display && changes.display.currentValue != undefined) {
            this.currentDisplay = changes.display.currentValue;
            this.displaPopup(changes.display.currentValue)
        }
        if (changes.workbookName && changes.workbookName.currentValue) {
            this.workbookName = changes.workbookName.currentValue;
        }
        if (changes.workspaceName && changes.workspaceName.currentValue) {
            this.workspaceName = changes.workspaceName.currentValue;
        }
    }

    checkSubscriptionLimit(){
        this.appMainService.isShowSpinner('checkSubscriptionLimit');
        this.organizationSubscriptionService
        .getFeatureSubscriptionInfo(FeatureSubscriptionInfoEnums.Export)
        .pipe(takeUntil(this.ngUnsubscribe)).subscribe({
            next: (response)=>{
                this.subscriptionLimit = response;
                this.appMainService.isHideSpinner('checkSubscriptionLimit');
            },
            error: (error)=>{
                this.appMainService.isHideSpinner('checkSubscriptionLimit');
            }
        })
    }

    get subscriptionLimitReached(){
        return (this.subscriptionLimit?.allowedLicence && this.subscriptionLimit?.allowedLicence<=this.subscriptionLimit?.consumedLicense)
    }

    displaPopup(currentDisplayValue) {
        // debugger
        this.processExportInitialData();
        this.listSearchInput = '';
        this.cdr.detectChanges();
        this.displayExport = currentDisplayValue;
        if(this.displayExport){
            this.checkSubscriptionLimit();
        }
    }

    trackByName(index: number, item: any) {
        return item.labelname;
    }

    dropCol(event: CdkDragDrop<string[]>) {
        moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    }

    dropColBlock(event: CdkDragDrop<string[]>) {
        moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    }

    exportData() {
        this.updateExportModel.columns = [];
        this.updateExportModel.stageId = this.stageId||null;
        let fields = [];
        this.currentallListColumns.forEach(element => {
            element.fields.forEach((field) => {
                if(field?.childFields.length > 0){
                    fields = [...fields, ...field?.childFields]
                }
                fields.push(field);
            });
        });
        this.updateExportModel.columns = fields.filter(field => field.enabled && field?.columnName && !field?.childFields?.length)
                                                .map(field => ({ labelName: field?.name, columnName: field?.columnName}));

        if (this.updateExportModel?.columns?.length == 0) {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'No column selected' });
            return;
        }
            this.showExportFileType=true
    }

    downloadSavedSearch(typeOfExportFile:string){
        this.updateExportModel.typeOfExportFile = typeOfExportFile;
        this.startExport();
        this.showExportFileType=false;
    }

    showChild(col) {
        col.showChildrens = col.showChildrens != undefined ? !col.showChildrens : true;
    }

    startExport() {

        if (!this.channelId) {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Channel not found' });
            return;
        }

        if((this.moduleName == 'Opportunity' || this.moduleName == 'Cases') && this.accountChannelId){
            this.updateExportModel.accountChannelId = this.accountChannelId;
        }
        this.updateExportModel.columns?.forEach((data)=>{
            if(data.columnName == 'tags'){
                data.columnName = 'tagsCsv'
            }
        })

        this.appMainService.isShowSpinner('exportData');
        this.sharedExportService.ExportData(this.updateExportModel)
                .pipe(takeUntil(this.ngUnsubscribe))
                .subscribe({
                    next: (response) => {

                        this.appMainService.isHideSpinner('exportData');
                        this.displayExport = false;
                        this.onExportComplete.emit({});
                        this.messageService.add({
                            severity: 'success',
                            summary: 'Success',
                            detail: 'Export request is in process...'
                          });

                    },
                    error: (error) => {
                        this.displayExport = false;
                        this.appMainService.isHideSpinner('exportData');
                        this.messageService.add({
                            severity: 'error',
                            summary: 'Error',
                            detail: error?.error?.message ? error?.error?.Message : 'Failed upload to storage...'
                        });

                    },
                    complete: () => {},
                })

    }

    processExportInitialData(): void {
        this.updateExportModel.channelId = this.channelId;
        this.updateExportModel.moduleId = this.objectId;
        this.updateExportModel.tableId = this.workbookId;
        this.updateExportModel.isActive = this.isActive;
        this.updateExportModel.workbookName = this.workbookName;
        this.updateExportModel.workspaceName = this.workspaceName;
        this.updateExportModel.filter = this.selectedRecent?.code ? this.selectedRecent?.code : '';
    }

    ngOnDestroy() {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }

    enableAllSectionFields($event: any, sections: any[]) {

        const checked = !!$event?.checked;
        this.isSelectAllSectionField = checked;

        sections?.forEach((section) => {
            this.enableSectionFields({ checked: checked }, section);
        });
    }
    enableSectionFields($event: any, section: any) {
        const checked = !!$event?.checked;

        section?.fields?.forEach(field => {
            if (field?.childFields?.length) {
                field.childFields.forEach(childField => {
                    // const isChildDisabled = childField?.isRequired && childField?.enabled;
                    const enabled = checked;

                    if (childField.enabled !== enabled) {
                        childField.enabled = enabled;
                    }
                });
            } else {
                // const isDisabled = this.isFieldDisabled(field);
                const enabled = checked;

                if (field.enabled !== enabled) {
                    field.enabled = enabled;
                }
            }
        });
    }

    isFieldDisabled(field: any): boolean {
        return (
            field?.columnName === 'businessName' ||
            (field.enabled && field?.columnName === 'sequenceNumber' && this.objectId === AccountModuleId) ||
            (this.objectId === OpportunityModuleId && field?.columnName === 'name') ||
            (this.objectId === CaseModuleId && field?.columnName === 'associationName' && field.enabled)
        );
    }

    cancelExport() {
        this.cancelClicked.emit({});
    }




}
